// extracted by mini-css-extract-plugin
export default {"iconVerified":"IconVerifiedBadge_iconVerified__jX6r1"};